import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const baseURI = config.companyApiUrl;
const setupURI = config.setupApiUrl;
const isDlb = config.isDlb;

const ediIdStoreModule = {
  // namespaced: false,

  state: {
    ediIdList: [],
    ediIdListTemp: [],
    compEdiIdList: [],
    prnrEdiIdList: [],
    chkEdiId: {},
    //2022/04/25 213960 SPKA-443 Modify new workflow detail pop-up
    senderEdiIdList: [],
    receiverEdiIdList: [],
    senderEdiIdChange: {},
    receiverEdiIdChange: {},
  },
  mutations: {
    SET_STORE_EDI_ID_LIST(state, ediIdList) {
      if (
        JSON.stringify(state.ediIdListTemp) !== JSON.stringify(ediIdList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('EDI');
      }
      ediIdList === '' ? (state.ediIdList = []) : (state.ediIdList = ediIdList);
      ediIdList === '' ? (state.ediIdListTemp = []) : (state.ediIdListTemp = ediIdList);
    },
    SET_STORE_COMP_EDI_ID_LIST(state, compEdiIdList) {
      compEdiIdList === '' ? (state.compEdiIdList = []) : (state.compEdiIdList = compEdiIdList);
    },
    SET_STORE_PRNR_EDI_ID_LIST(state, prnrEdiIdList) {
      prnrEdiIdList === '' ? (state.prnrEdiIdList = []) : (state.prnrEdiIdList = prnrEdiIdList);
    },
    SET_STORE_CHK_EDI_ID(state, chkEdiId) {
      state.chkEdiId = chkEdiId;
    },
    SET_STORE_EDI_ID_LIST_FILTER(state, filter) {
      let datarows = state.ediIdListTemp;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
          return false;
        });
      }
      state.ediIdList = listResult;
    },
    SET_STORE_SENDER_EDI_ID_LIST(state, senderEdiIdList) {
      state.senderEdiIdChange = compareTableData(state.senderEdiIdList, senderEdiIdList, 'srId');
      senderEdiIdList === ''
        ? (state.senderEdiIdList = [])
        : (state.senderEdiIdList = senderEdiIdList);
    },
    SET_STORE_RECEIVER_EDI_ID_LIST(state, receiverEdiIdList) {
      state.receiverEdiIdChange = compareTableData(
        state.receiverEdiIdList,
        receiverEdiIdList,
        'srId'
      );
      receiverEdiIdList === ''
        ? (state.receiverEdiIdList = [])
        : (state.receiverEdiIdList = receiverEdiIdList);
    },
  },
  actions: {
    getEdiIdList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/list`, params);
        commit('SET_STORE_EDI_ID_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    getCompEdiIdList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/list/comp`, params);
        commit('SET_STORE_COMP_EDI_ID_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    _getCompEdiIdList: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${baseURI}/ediid/list/comp/${params.compId}`, params);
        commit('SET_STORE_COMP_EDI_ID_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    getPrnrEdiIdList: async ({ commit }, params) => {
      try {
        const response = await axios.post(
          `${baseURI}/ediid/list/${params.prnrId}/${params.compId}`,
          params
        );
        commit('SET_STORE_PRNR_EDI_ID_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    // 2021.3.30 203728 Get EDI list for Partner
    getPrnrEdiListNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/partner/getList`, params);
        // 2021.5.6 203728 Check partner's edi use in workflow
        let rtnData = response.data;
        if (rtnData.length > 0) {
          if (!isDlb) {
            let edis = rtnData.map((e) => e.id);
            const res = await axios.post(`${setupURI}/process/check/listUseInWorkflow`, {
              obj: 'EDIList',
              listChk: edis,
            });
            rtnData.map((e) => {
              let num = res.data.findIndex((r) => r.ediId == e.id);
              e.numOfUse = num > -1 ? res.data[num].numOfUse : 0;
            });
          } else {
            rtnData.map((e) => (e.numOfUse = 0));
          }
        }
        commit('SET_STORE_PRNR_EDI_ID_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    // 2021.3.30 203728 Get EDI list for Company
    getCompanyEdiListNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/company/getList`, params);
        // 2021.5.6 203728 Check company's edi use in workflow
        let rtnData = response.data;
        if (rtnData.length > 0) {
          if (!isDlb) {
            let edis = rtnData.map((e) => e.id);
            const res = await axios.post(`${setupURI}/process/check/listUseInWorkflow`, {
              obj: 'EDIList',
              listChk: edis,
            });
            rtnData.map((e) => {
              let num = res.data.findIndex((r) => r.ediId == e.id);
              e.numOfUse = num > -1 ? res.data[num].numOfUse : 0;
            });
          } else {
            rtnData.map((e) => (e.numOfUse = 0));
          }
        }
        // console.log(response.data);
        commit('SET_STORE_COMP_EDI_ID_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    insertEdiId: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/insert`, params);
        // console.log(response.data);
        await commit('SET_STORE_EDI_ID_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    updateEdiId: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/update`, params);
        // console.log(response.data);
        await commit('SET_STORE_EDI_ID_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    deleteEdiId: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/delete`, params);
        // console.log(response.data);
        await commit('SET_STORE_EDI_ID_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    checkEdiId: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/ediid/check`, params);
        // console.log(response.data);
        await commit('SET_STORE_CHK_EDI_ID', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    getSenderEdiIdList: async ({ commit }, params) => {
      try {
        if (params.prnrId && params.compId) {
          let response = await axios.post(
            `${baseURI}/ediid/list/${params.prnrId}/${params.compId}`,
            params
          );
          commit('SET_STORE_SENDER_EDI_ID_LIST', response.data);
          return response.data;
        } else {
          let response = await axios.get(`${baseURI}/ediid/list/comp/${params.compId}`, params);
          commit('SET_STORE_SENDER_EDI_ID_LIST', response.data);
          return response.data;
        }
      } catch (err) {
        throw err;
      }
    },
    getReceiverEdiIdList: async ({ commit }, params) => {
      try {
        if (params.prnrId && params.compId) {
          let response = await axios.post(
            `${baseURI}/ediid/list/${params.prnrId}/${params.compId}`,
            params
          );
          commit('SET_STORE_RECEIVER_EDI_ID_LIST', response.data);
        } else {
          let response = await axios.get(`${baseURI}/ediid/list/comp/${params.compId}`, params);
          commit('SET_STORE_RECEIVER_EDI_ID_LIST', response.data);
        }
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    ediIdList: (state) => state.ediIdList,
    compEdiIdList: (state) => state.compEdiIdList,
    prnrEdiIdList: (state) => state.prnrEdiIdList,
    chkEdiId: (state) => state.chkEdiId,
    senderEdiIdList: (state) => state.senderEdiIdList,
    receiverEdiIdList: (state) => state.receiverEdiIdList,
    senderEdiIdChange: (state) => state.senderEdiIdChange,
    receiverEdiIdChange: (state) => state.receiverEdiIdChange,
  },
};

export default ediIdStoreModule;
